mtl.alloy.factory['faq-accordion'] = (function($, app, util) {
	'use strict';

	/**
	 * Controller for the layout header element.
	 */
	return function(element, options) {

		var $element = $(element);

		// ---------------------------------------------------------

		/*
		 * Toggle question
		 */
		function toggleQuestion($question) {

			var $li = $question.parent();
			var $answer = $('.faq-answer', $li);

			if($li.hasClass('active'))
			{
				$answer.slideUp(400, function(){
					$li.removeClass('active');
				});
			} else {
				$li.addClass('active');
				$answer.hide();
				$answer.slideDown();
			}

		}


		// Open the login form when the login button is clicked
		$element.on('click', '.faq-question', function(event) {
			event.preventDefault();
			toggleQuestion($(this));
		});

	};

}($, app, util));
